import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import OtpVerificationStep from '../../../components/auth/OtpVerificationStep';
import { useOtpFlow } from '../hooks/useOtpFlow';
import { InlineError, SignupShell } from '../components/SignupShell';
import { linkButtonClass } from '../constants';

/** The signup email already has an account: log in with a code, then keep paying here. */
export const ExistingAccountStep: React.FC<{
    email: string;
    onVerified: () => Promise<void>;
    onBack: () => void;
}> = ({ email, onVerified, onBack }) => {
    const { verifyOTP, sendOTP } = useAuth();
    const otp = useOtpFlow({
        send: async () => {
            const result = await sendOTP(email);
            return result.success ? null : (result.error || 'No pudimos enviar el código. Usa "Reenviar".');
        },
        verify: async code => {
            const result = await verifyOTP(email, code);
            return result.success ? null : (result.error || 'Código incorrecto');
        },
        onVerified,
    });

    return (
        <SignupShell title="Ya tienes una cuenta" subtitle="Valida tu correo para continuar con el pago">
            <div className="space-y-4">
                <InlineError message={otp.error} />
                <OtpVerificationStep
                    email={email}
                    code={otp.code}
                    onCodeChange={otp.setCode}
                    onSubmit={otp.submit}
                    onResend={otp.resend}
                    loading={otp.loading}
                    title="Te enviamos un código"
                >
                    <p className="text-sm text-gray-600">
                        <button type="button" onClick={onBack} disabled={otp.loading} className={linkButtonClass}>
                            Usar otro correo
                        </button>
                    </p>
                </OtpVerificationStep>
            </div>
        </SignupShell>
    );
};
